<template>
  <b-row>
    <b-col>
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions /></div>
            <div class="list-view-heading__controls-end">
              <b-button @click="add()" type="button" variant="link" class="list-view-icon-btn list-view-icon-btn--primary"
                        v-b-tooltip.hover.bottom title="Agregar motivo" aria-label="Agregar motivo">
                <AppIcon name="add" />
              </b-button>
            </div>
          </div>
        </section>
      </b-card>

      <b-card>
        <b-row>
          <b-col>
            <b-table class="app-table mb-0"
                    ref="table"
                    :stacked="isMobileViewport ? 'md' : false"
                    sticky-header="60vh"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="table.items"
                    :fields="table.fields"                    
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    :busy="table.isBusy"
                    v-if="table.items.length || table.isBusy">                       
                
                <template v-slot:cell(id)="data">
                  <b>#{{data.item.id}}</b>
                </template>

                <template v-slot:cell(code)="data">
                  <b>{{data.item.code}}</b>
                </template>
                
                <template v-slot:cell(reference)="data">
                  <b>{{data.item.reference}}</b>
                </template>

                <template v-slot:cell(name)="data">
                  {{data.item.name}}
                </template>
               
                <template v-slot:cell(available_all_customers)="data">
                  <b-badge variant="success" v-if="data.item.available_all_customers">Sí</b-badge>
                  <span class="text-muted" v-else>No</span>
                </template>
               
                <template v-slot:cell(system)="data">
                  <div>
                    <strong>Buscar Precios: </strong>
                    <span class="text-info" v-if="data.item.only_published">SOLO PRODUCTOS PUBLICADOS</span>
                    <span class="text-success" v-else>TODOS LOS PRODUCTOS</span>                    
                  </div>
                </template>                

                <template v-slot:cell(website)="data">                
                  <div v-if="data.item.website_show">
                    <div>
                      <strong>Mostrar: </strong>
                      <span v-if="data.item.website_show_only_published">
                        <span class="text-info" v-if="data.item.website_show_intro_price_list">
                          SOLO PRODUCTOS PUBLICADOS EN LISTA DE PRECIO
                        </span>
                        <span class="text-info" v-else>
                          SOLO PRODUCTOS PUBLICADOS
                        </span>
                      </span>
                      <span v-else>
                        <span class="text-success" v-if="data.item.website_show_intro_price_list">
                          TODOS LOS PRODUCTOS EN LISTA DE PRECIO
                        </span>
                        <span class="text-success" v-else>
                          TODOS LOS PRODUCTOS
                        </span>
                      </span>                                        
                    </div>
                    <div v-if="!data.item.website_show_only_published && data.item.website_show_legend_not_published">                    
                      <strong>Leyenda "NO PUBLICADOS": </strong>
                      <b-badge variant="warning">{{data.item.website_legend_not_published}}</b-badge>
                    </div>
                  </div>
                  <div v-else>
                    <b-badge variant="danger">NO MOSTRAR</b-badge>
                  </div>
                </template>

                <template v-slot:cell(order)="data">
                  <b-badge variant="secondary">{{data.item.order}}</b-badge>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right no-caret size="sm" variant="link" boundary="window" toggle-class="app-table-action-toggle">
                    <template #button-content><AppIcon name="more_vert" label="Opciones" /><span class="app-table-action-label">Opciones</span></template>
                    <b-dropdown-item @click="edit(data.item)">
                      <AppIcon name="edit" class="mr-1" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)">
                      <AppIcon name="delete" class="mr-1 text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else icon="assignment" title="No hay motivos de pedido" description="Agregá un motivo para organizar la toma de pedidos." />
          </b-col>
        </b-row>
      </b-card>

      <b-card body-class="py-2">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <AppIcon name="back" class="mr-1" />
              Volver
            </b-button>                        
          </b-col>

          <b-col>            
            <nav v-if="table.tablePaginate">
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="table.tablePaginate.total"
                            :per-page="table.tablePaginate.per_page"
                            v-model="table.currentPage" 
                            @input="filter()" />
            </nav>             
          </b-col>          
        </b-row>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              body-class="app-modal-form"
              :key="modal.form._id"
              :id="modal.form._id">                  
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="assignment" /></span>
          <h5 class="app-modal-header__title">{{ modal.form.title }}</h5>
        </div>

        <b-row>      
          <b-col md="12" class="mb-3">
            <b-form-checkbox v-model="crud.form.available_all_customers" 
                              switch 
                              size="sm">
              Disponible para todos los Clientes
            </b-form-checkbox> 
          </b-col>                    
          <b-col md="6">
            <b-form-group label="Orden" description="Valor utilizado para ordenar los motivos en las vistas">
              <b-form-input type="number"
                            size="sm"
                            v-model="crud.form.order"
                            required
                            placeholder="Ingresar un orden numérico">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Referencia">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.reference"
                            required
                            placeholder="Ingresar una referencia">
              </b-form-input>
            </b-form-group>
          </b-col>                                                      
          <b-col md="4">
            <b-form-group label="Código">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.code"
                            required
                            placeholder="Ingresar un código">
              </b-form-input>
            </b-form-group>
          </b-col>                                                
          <b-col md="8">
            <b-form-group label="Nombre">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.name"
                            required
                            placeholder="Ingresar un nombre">
              </b-form-input>
            </b-form-group>
          </b-col>            
          <b-col md="12">
            <FindObject render="search"
                        type="priceList" 
                        @select-object="loadPriceList($event)" 
                        :valueID="crud.form.price_list_id"
                        :key="crud.form.price_list_id" 
                        :where="conditionPriceListActive" />
          </b-col>
          <b-col md="12" class="mt-2">
            <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
              <b-tab>
                <template #title><AppIcon name="settings" class="mr-1" /> Sistema</template>
                <b-row>
                  <b-col md="12" class="mb-1">
                    <b-form-checkbox v-model="crud.form.only_published" 
                                      switch 
                                      size="sm">
                      Buscar precios solo en productos publicados
                    </b-form-checkbox>                 
                  </b-col>              
                </b-row>
              </b-tab>
              <b-tab>
                <template #title><AppIcon name="language" class="mr-1" /> Sitio web</template>
                <b-row>         
                  <b-col md="12" class="mb-1">
                    <b-form-checkbox v-model="crud.form.website_show" 
                                      switch 
                                      size="sm">
                      Mostrar en Sitio Web
                    </b-form-checkbox> 
                  </b-col>              
                </b-row>

                <b-row v-if="crud.form.website_show">         
                  <b-col md="12" class="mb-1">
                    <hr>
                  </b-col>
                  <b-col md="12" class="mb-1">
                    <b-form-checkbox v-model="crud.form.website_show_only_published" 
                                      switch 
                                      size="sm">
                      Mostrar solo productos publicados
                    </b-form-checkbox> 
                  </b-col>       
                  <b-col md="12" class="mb-1">
                    <b-form-checkbox v-model="crud.form.website_show_intro_price_list" 
                                      switch 
                                      size="sm">
                      Mostrar solo productos dentro de lista de precios
                    </b-form-checkbox> 
                  </b-col>     
                  <b-col md="12" v-if="!crud.form.website_show_only_published">
                    <hr>
                  </b-col>
                  <b-col md="12" class="mb-1" v-if="!crud.form.website_show_only_published">
                    <b-form-checkbox v-model="crud.form.website_show_legend_not_published" 
                                      switch 
                                      size="sm">
                      Leyenda para productos "No Publicados"
                    </b-form-checkbox> 
                  </b-col>                                       
                  <b-col md="12" v-if="!crud.form.website_show_only_published && 
                                      (crud.form.website_show_legend_not_published || crud.form.website_show_legend_not_published == 'true')">
                    <b-form-group label="Leyenda para productos no publicados">
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="crud.form.website_legend_not_published"
                                    required
                                    placeholder="Ingresar una leyenda">
                      </b-form-input>
                    </b-form-group>
                  </b-col>    
                </b-row>                                                      
              </b-tab>
            </b-tabs>
          </b-col>                        
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false"><AppIcon name="x" class="mr-1" />Cancelar</b-button>
          <b-button variant="primary" @click="save()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>    
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import FindObject from '@/components/inc/find/findObject'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      FindObject,
      TabHeaderActions,
    },        
    data: () => {
      return {      
        isMobileViewport: false,
        mobileMql: null,
        access: {
          module_id: Modules.PEDIDOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudOrdersReason',
          elements: {}
        },         
        table : {
          items: [],
          fields: [
            {key: 'id', label: 'ID', sortable: true, class: 'align-middle'},
            {key: 'code', label: 'Código', class: 'align-middle'},      
            {key: 'reference', label: 'Referencia', class: 'align-middle'},      
            {key: 'name', label: 'Nombre', class: 'align-middle'},                               
            {key: 'available_all_customers', label: 'Todos los Clientes', class: 'text-center align-middle'},                               
            {key: 'system', label: 'Sistema', class: 'align-middle'},                               
            {key: 'website', label: 'Sitio Web', class: 'align-middle'},                               
            {key: 'order', label: 'Orden', class: 'text-center align-middle'},                               
            {key: 'f_action', label:'', class: 'text-center'},
          ],          
          currentPage: 1,
          perPage: 0,
          isBusy: false,
          tablePaginate: null,                
        },
        crud: {
          form: {
            id: 0,
            code: '',
            reference: '',
            name: '',                   
            price_list_id: 0,
            price_list: null,
            order: 0,
            only_published: false,    
            available_all_customers: true,   
            website_show: false,
            website_show_only_published: true,
            website_show_intro_price_list: true,
            website_show_legend_not_published: false,
            website_legend_not_published: 'SIN STOCK',
          },          
        },
        modal: {
          form: {
            active: false,
            title: ''
          },       
        },
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.filter()
    },
    beforeDestroy() {
      if (this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
    },
    computed: {
      // CONDITIONS SELECT
      conditionPriceListActive(){
        return [{field: 'active', condition: true}];
      },        
    },
    methods: {
      updateMobileViewport(event) {
        this.isMobileViewport = event.matches
      },
      // select 
      loadPriceList (object) {
        if(object){
          this.crud.form.price_list = object
          this.crud.form.price_list_id = object.id             
        } else {
          this.crud.form.price_list = null
          this.crud.form.price_list_id = 0
        }
      }, 
            
      // crud
      filter() {
        this.table.isBusy = true

        var result = serviceAPI.filtrarMotivos(this.filters, this.table.currentPage)

        result.then((response) => {
          var data = response.data
          this.table.tablePaginate = data

          this.table.items = data.data

          if(this.$refs.table) {                        
            this.$refs.table.$forceUpdate()
          }  

          this.table.isBusy = false          
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });        
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.code = '' 
        this.crud.form.reference = '' 
        this.crud.form.name = '' 
        this.crud.form.price_list_id = 0
        this.crud.form.price_list = null    
        this.crud.form.order = 0    
        this.crud.form.only_published = false
        this.crud.form.available_all_customers = true
        this.crud.form.website_show = false
        this.crud.form.website_show_only_published = true
        this.crud.form.website_show_intro_price_list = true
        this.crud.form.website_show_legend_not_published = false
        this.crud.form.website_legend_not_published = 'SIN STOCK'

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Motivo"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.code = item.code
        this.crud.form.reference = item.reference       
        this.crud.form.name = item.name
        this.crud.form.price_list_id = item.price_list_id
        this.crud.form.price_list = item.price_list
        this.crud.form.order = item.order
        this.crud.form.only_published = item.only_published
        this.crud.form.available_all_customers = item.available_all_customers
        this.crud.form.website_show = item.website_show
        this.crud.form.website_show_only_published = item.website_show_only_published
        this.crud.form.website_show_intro_price_list = item.website_show_intro_price_list
        this.crud.form.website_show_legend_not_published = item.website_show_legend_not_published
        this.crud.form.website_legend_not_published = item.website_legend_not_published

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Motivo"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name        

        this.confirmDialog('¿Desea borrar el motivo (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar motivo',
          icon: 'delete',
          danger: true,
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarMotivos(this.crud.form.id);

            result.then(() => {
              this.modal.form.active = false        
              loader.hide()
              this.filter()
              this.$awn.success("Motivo Eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();

        var result = null
        if (this.crud.form.id) {
          result = serviceAPI.editarMotivos(this.crud.form);
        } else {
          result = serviceAPI.agregarMotivos(this.crud.form);
        }

        result.then(() => {
          this.modal.form.active = false
          loader.hide()
          this.filter()
          this.$awn.success("Cambios guardado con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      confirmDialog(message, options) {
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: options.icon || 'warning' } }),
          options.title,
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: options.danger ? 'danger' : 'dark',
          okTitle: 'Sí',
          cancelTitle: 'No',
          footerClass: 'p-2',
          headerClass: options.danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true,
        })
      },
    }    
  }
</script>
<style>

</style>
